<h2 class="competency-header">Self-assess your proficiency in your selected competencies</h2>
<p>Use the rating scale below to assess your current level of proficiency in each of your chosen competencies. You can
    also use the examples listed under each competency to help with this assessment. Also consider any feedback you have
    received or experiences you have had that might suggest a certain proficiency level.</p>
<p><strong>These selections will not be seen by the Law Society.</strong> They are to help you assess your proficiency levels so you can
     prioritize your competencies in the next step. They will also help you track your progress later, as you complete
     learning activities in the competencies you choose for your CPD plan.</p>
<div aria-live="assertive">
    <div role="alert" class="validation-msg" *ngIf="showError  && !isValid()">
        Select a rating for each Competency to continue.
    </div>
</div>

<mat-card appearance="outlined" class="assessment" [ngClass]="{'invalid' : showError && !competency.Rating }"
    *ngFor="let competency of competencies">
    <h3 class="second-title" color="primary">{{competency.Name}}</h3>
    <p *ngIf="groupedCompetencies">{{getCompetencyDescription(competency.Domain, competency.Name)}}</p>
    <div class="rating" id="rating">Select a Rating</div>
    <div class="container">
        <mat-chip-listbox [title]="competency.Name" name="competency.Id" class="chip-scale" selectable aria-labelledby="rating">
            <mat-chip-option #a (click)="clickSelection(a, competency)" (keydown.space)="keyboardSelection($event, a, competency)" [selected]="isSelected(a, competency)"
                value="Pre-discovery" [title]="'Pre-discovery - ' + competency.Name">
                <div class="card-title">Pre-discovery</div>
                <div class="card-body" [id]="'pre-discovery'+competency.Id">Lacks awareness of the competency or its relevance to professional practice</div>
            </mat-chip-option>
            <mat-chip-option #b (click)="clickSelection(b, competency)" (keydown.space)="keyboardSelection($event, b, competency)" [selected]="isSelected(b, competency)"
                value="Discover" [title]="'Discover - ' + competency.Name">
                <div class="card-title">Discover</div>
                <div class="card-body">Express curiosity about, develops awareness of, or learns about the competency
                </div>
            </mat-chip-option>
            <mat-chip-option #c (click)="clickSelection(c, competency)" (keydown.space)="keyboardSelection($event, c, competency)" [selected]="isSelected(c, competency)"
                value="Attempt" [title]="'Attempt - ' + competency.Name">
                <div class="card-title">Attempt</div>
                <div class="card-body">Tests out the competency, learns through mistakes, or engages in deliberate
                    practice</div>
            </mat-chip-option>
            <mat-chip-option #d (click)="clickSelection(d, competency)" (keydown.space)="keyboardSelection($event, d, competency)" [selected]="isSelected(d, competency)"
                value="Do" [title]="'Do - ' + competency.Name">
                <div class="card-title">Do</div>
                <div class="card-body">Demonstrates the competency with effort, conscious attention, or occasional
                    missteps or setbacks</div>
            </mat-chip-option>
            <mat-chip-option #e (click)="clickSelection(e, competency)" (keydown.space)="keyboardSelection($event, e, competency)" [selected]="isSelected(e, competency)"
                value="Excel" [title]="'Excel - ' + competency.Name">
                <div class="card-title">Excel</div>
                <div class="card-body">Demonstrates the competency proficiently, effortlessly, and habitually</div>
            </mat-chip-option>
            <mat-chip-option #f (click)="clickSelection(f, competency)" (keydown.space)="keyboardSelection($event, f, competency)" [selected]="isSelected(f, competency)"
                value="Lead" [title]="'Lead - ' + competency.Name">
                <div class="card-title">Lead</div>
                <div class="card-body">Models this competency for others or uses it to transform practice</div>
            </mat-chip-option>
        </mat-chip-listbox>
    </div>
</mat-card>
